export const firebaseConfig = {
  apiKey: "AIzaSyCNpcVuuNWJ6EIxDE3Gdw8rXhIQ6Ds0Org",
  authDomain: "elite-compensation.firebaseapp.com",
  projectId: "elite-compensation",
  storageBucket: "elite-compensation.appspot.com",
  messagingSenderId: "918561603337",
  appId: "1:918561603337:web:c049c5a567c28410855dd8",
  measurementId: "G-FHJBBZDEY0",
};
